import React, { ReactNode } from 'react';
import Markdown from 'markdown-to-jsx';

import {
  FloatingRightContainer,
  HighlightImage,
  MainContentWrapper,
  MobileHighlightImage,
  ProLogo,
  ProPlanContainer, TopBanner
} from 'elements/pricing/ProPlanCTA.styles';
import Heading from 'elements/typography/heading';

interface ProPlanCTAProps {
  description: string;
  cta: ReactNode;
  highlightImageUrl: string;
  logoUrl: string;
  floatingShapeText: string;
}

const ProPlanCTA = (props: ProPlanCTAProps): JSX.Element => {
  const { description, cta, floatingShapeText, highlightImageUrl, logoUrl } = props;

  return (
    <ProPlanContainer>
      <MainContentWrapper>
        <TopBanner>
          <Heading text="The Best Plan for Brands, Organizations & Successful Creators"
            size="16px"
            level={2}
            align="center"/>
        </TopBanner>

        <ProLogo className="logo-image-desktop"
          src={logoUrl} alt="logo image "/>
        <MobileHighlightImage src={highlightImageUrl}
          alt="highlight image"
          aria-hidden/>
        <Markdown>
          {description}
        </Markdown>

        {cta}
      </MainContentWrapper>

      <div>
        <HighlightImage src={highlightImageUrl} aria-hidden
          alt="highlight image"/>
      </div>

      <FloatingRightContainer>
        <div className="content">
          <Markdown>
            {floatingShapeText}
          </Markdown>
        </div>
        <div className="white-shape"/>
      </FloatingRightContainer>
    </ProPlanContainer>
  );
};

export default ProPlanCTA;
